import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'bfd-calendar-month',
  templateUrl: './bfd-calendar-month.component.html',
  styleUrls: ['./bfd-calendar-month.component.scss']
})
export class CalendarMonthComponent implements OnInit {

  @Output() dateClick = new EventEmitter<Date>();
  @Output() invalidMonthSelected = new EventEmitter<string>();
  @Input() selectedStart: Date | null = null;
  @Input() selectedEnd: Date | null = null;
  @Input() allowFutureDates: boolean = false;
  @Input() position: 'left' | 'right' = 'left';

  @Input() monthBase: number;
  @Input() yearBase: number;
  @Input() monthOffset: number = 0;

  @Output() requestNextMonth = new EventEmitter<void>();
  @Output() requestPrevMonth = new EventEmitter<void>();
  @Output() requestNextYear = new EventEmitter<void>();
  @Output() requestPrevYear = new EventEmitter<void>();

  displayedMonth: number;
  displayedYear: number;

  weekDays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
  days: { date: Date, outside: boolean }[] = [];

  today = new Date();
  selectedRange: { start: Date | null, end: Date | null } = { start: null, end: null };

  ngOnInit() {
    const baseDate = new Date();
    baseDate.setMonth(baseDate.getMonth() + this.monthOffset);
    this.displayedMonth = baseDate.getMonth();
    this.displayedYear = baseDate.getFullYear();
    this.generateCalendar();
  }
  ngOnChanges() {
    if (this.monthBase != null && this.yearBase != null) {
      const date = new Date(this.yearBase, this.monthBase + this.monthOffset, 1);
      this.displayedMonth = date.getMonth();
      this.displayedYear = date.getFullYear();
      this.generateCalendar();
    }
  }

  getMonthName(month: number): string {
    const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    return months[month];
  }

  generateCalendar() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const firstDay = new Date(this.displayedYear, this.displayedMonth, 1);
    const startDay = firstDay.getDay();
    const daysInMonth = new Date(this.displayedYear, this.displayedMonth + 1, 0).getDate();

    this.days = [];

    const prevMonthDays = new Date(this.displayedYear, this.displayedMonth, 0).getDate();

    // Dias do mês anterior
    for (let i = startDay - 1; i >= 0; i--) {
      const date = new Date(this.displayedYear, this.displayedMonth - 1, prevMonthDays - i);
      this.days.push({
        date,
        outside: true,
        disabled: this.allowFutureDates
          ? this.dateIsPast(date)
          : this.dateIsFuture(date)
      } as any);
    }

    // Dias do mês atual
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(this.displayedYear, this.displayedMonth, i);
      this.days.push({
        date,
        outside: false,
        disabled: this.allowFutureDates
          ? this.dateIsPast(date)
          : this.dateIsFuture(date)
      } as any);
    }

    // Dias do próximo mês
    const totalDays = startDay + daysInMonth;
    const nextDaysCount = (totalDays <= 35) ? (35 - totalDays) : (42 - totalDays);

    for (let i = 1; i <= nextDaysCount; i++) {
      const date = new Date(this.displayedYear, this.displayedMonth + 1, i);
      this.days.push({
        date,
        outside: true,
        disabled: this.allowFutureDates
          ? this.dateIsPast(date)
          : this.dateIsFuture(date)
      } as any);
    }
  }

  dateIsPast(date: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  }

  dateIsFuture(date: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date > today;
  }

  /*
  prevMonth() {
    if (this.displayedMonth === 0) {
      this.displayedMonth = 11;
      this.displayedYear--;
    } else {
      this.displayedMonth--;
    }
    this.generateCalendar();
  }

  nextMonth() {
    const today = new Date();
    const nextMonth = this.displayedMonth === 11 ? 0 : this.displayedMonth + 1;
    const nextYear = this.displayedMonth === 11 ? this.displayedYear + 1 : this.displayedYear;

    const nextDate = new Date(nextYear, nextMonth, 1);

    if (!this.allowFutureDates && nextDate > new Date(today.getFullYear(), today.getMonth(), 1)) {
      this.invalidMonthSelected.emit('Não é permitido selecionar um mês futuro.');
      return;
    }

    if (this.displayedMonth === 11) {
      this.displayedMonth = 0;
      this.displayedYear++;
    } else {
      this.displayedMonth++;
    }
    this.generateCalendar();
  }*/

  prevYear() {
    this.displayedYear--;
    this.generateCalendar();
  }

  nextYear() {
    const today = new Date();
    const nextYear = this.displayedYear + 1;

    if (!this.allowFutureDates && nextYear > today.getFullYear()) {
      this.invalidMonthSelected.emit('Não é permitido avançar para um ano futuro.');
      return;
    }

    this.displayedYear++;
    this.generateCalendar();
  }


  selectDate(date: Date) {
    this.dateClick.emit(date);
  }

  isSelected(date: Date): boolean {
    if (this.selectedStart && this.selectedEnd) {
      return date >= this.selectedStart && date <= this.selectedEnd;
    }
    if (this.selectedStart) {
      return (
        date.getFullYear() === this.selectedStart.getFullYear() &&
        date.getMonth() === this.selectedStart.getMonth() &&
        date.getDate() === this.selectedStart.getDate()
      );
    }
    return false;
  }

}
